import { defineStore } from 'pinia'
import { apiClient } from '@/lib/client'
import { useNotificationStore } from './notification.js'
import { useRouter } from 'vue-router'

export const useAuthStore = defineStore('auth', {
  state: () => ({
    user: null,
    token: localStorage.getItem('token') || null,
  }),

  getters: {
    isAuthenticated: (state) => !!state.token,
    isAdmin: (state) => {
      if (!state.token) { return false; }
      const roles = state.user?.roles ?? []
      return roles.some(role => role.name === 'admin')
    },
    getUser(state) {
      return state.user;
      try {
        return JSON.parse(localStorage.getItem('user'))
      } catch {
        return {
          username: 'xx'
        }
      }
    },

  },

  actions: {
    async login(username, password) {
      try {
        const response = await apiClient.post('/auth/login', { username, password })
        console.log(response);

        this.token = response.access_token
        this.user = response.user
        localStorage.setItem('token', this.token)

        return true
      } catch (err) {
        return false
      }
      
      //localStorage.setItem('user', JSON.stringify(this.user))
    },

    logout() {
      this.user = null
      this.token = null
      localStorage.removeItem('token')
      //localStorage.removeItem('user')
    },

    async autologin() {
      // dacă avem token în localStorage, încearcă să reîncarci user-ul
      if (this.token) {
        try {
          const response = await apiClient.get('/auth/me', {
            headers: { Authorization: `Bearer ${this.token}` },
          })
          this.user = response.data
        } catch (error) {
          console.warn('Autologin failed, token invalid/expired')
          this.logout()
        }
      }
    },
  },
})
